import { notifications } from '@mantine/notifications';
import { IconMoodPuzzled } from '@tabler/icons-react';
import { useQuery } from '@tanstack/react-query';
import { isNetworkError } from '@xver/libs/connectionNotifier';
import { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { Endpoints } from '../../../../../apis';

export function useSSHKeyQuery() {
    const { t } = useTranslation('notifications');
    const hasShownError = useRef(false);

    const { data, isPending, error } = useQuery({
        queryKey: ['api.v1.ssh-keys'],
        queryFn: async () => Endpoints.v1.SSHKeys.getSSHKeys(),
        retry: 2,
        retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000),
    });

    useEffect(() => {
        if (error && !isNetworkError(error) && !hasShownError.current) {
            hasShownError.current = true;
            notifications.show({
                title: t('query.failed'),
                message: t('query.sshKeysFailedMessage'),
                icon: <IconMoodPuzzled size={32} color={'#eb5757'} />,
            });
        }

        if (!error) {
            hasShownError.current = false;
        }
    }, [error, t]);

    return {
        data,
        isPending,
    };
}
